export default __webpack_public_path__ + "static/media/homeicon.505a3708.svg";